import {
  AolDark,
  AolLight,
  BabylistDark,
  BabylistLight,
  ForbesDark,
  ForbesLight,
  UsNewsDark,
  UsNewsLight,
  YahooDark,
  YahooLight,
} from "./Logos";

export const logo = {
  dark: {
    yahoo: YahooDark,
    babylist: BabylistDark,
    usnews: UsNewsDark,
    aol: AolDark,
    forbes: ForbesDark,
  },
  light: {
    yahoo: YahooLight,
    babylist: BabylistLight,
    usnews: UsNewsLight,
    aol: AolLight,
    forbes: ForbesLight,
  },
};
